<template>
  <div>
    <review stage="2" auditType="2" />
  </div>
</template>

<script>
  import review from './review'
  export default {
    name: "secondSReview",
    components:{review},
  }
</script>